import MyPage from '@/pages/mypage/MyPage';

export default [
  { path: `/mypage`, component: MyPage, name: 'mypage'},
]
